// import { removeNullCharacters } from 'pdfjs-dist';
import * as type from '../../types/trans';


let init = {
    sipAmount: 0,
    LumsumAmount: 0,
    ISIPAmount: 0,
    cartIdArray: [],
    CART_ARRAY: [],
    utrNo: "",
    cartId: null,
    showButton: null,
    DistcartId: null,
    DistshowButton: null,
    dirDistCartId_new: [],
    regDistCartId_new: [],
    error: {},
    addDist: "false",
    selectFolio: null,
    LUMP_TYPE: null,
    ISIP_TYPE: null,
    SIP_TYPE: null,
    bucketId: null,
    MANDATE_NAME: null,
    MANDATE_NUMBER: null,
    MANDATE_IHNO: null,
    SIP_TYPE: null,
    MANDATE_IHNO: null,
    PG: null,
    IFSC: null,
    RAZORPAYKEY: null,
    BUCKET_ID: null,
    iSipChk: "false",
    isMandate: null,
    isMandateAvail: "",
    isTwoPayment: "",
    foliono: "",
    plan: "",
    ALL_FUND_DETAILS: [],
    PAYMENT_MODE: ''
};



export default function cartDetails(state = init, action) {
    switch (action.type) {
        case type.RAZORPAYKEY:
            return {
                ...state,
                RAZORPAYKEY: action.payload
            }
        case type.IFSC:
            return {
                ...state,
                IFSC: action.payload
            }
        case type.PG:
            return {
                ...state,
                PG: action.payload
            }
        case type.SIP_AMOUNT:
            return {
                ...state,
                sipAmount: action.payload.sipAmount
            }

        case type.LUM_AMOUNT:
            return {
                ...state,
                LumsumAmount: action.payload.LumsumAmount
            }

        case type.ISIP_AMOUNT:
            return {
                ...state,
                ISIPAmount: action.payload.isipAmount
            }

        case type.CART_ID:
            return {
                ...state,
                cartIdArray: action.payload.cartIdArray
            }

        case type.CART_ARRAY:
            return {
                ...state,
                CART_ARRAY: action.payload.CART_ARRAY
            }

        case type.BANK_NAME:
            return {
                ...state,
                BANK_NAME: action.payload
            }

        case type.BANK_NUMBER:
            return {
                ...state,
                BANK_NUMBER: action.payload
            }
        case type.CHEQUE_MODE:
            return {
                ...state,
                CHEQUE_MODE: action.payload
            }

        case type.PAYMENT_MODE:
            return {
                ...state,
                PAYMENT_MODE: action.payload
            }

        case type.ISIP_TYPE:
            return {
                ...state,
                ISIP_TYPE: action.payload
            }

        case type.SIP_TYPE:
            return {
                ...state,
                SIP_TYPE: action.payload
            }

        case type.LUMP_TYPE:
            return {
                ...state,
                LUMP_TYPE: action.payload
            }

        case type.UTR_NO:
            return {
                ...state,
                utrNo: action.payload
            }

        case type.BROKER_CART_ID:
            return {
                ...state,
                cartId: action.payload.Id,
                showButton: action.payload.flag
            }
        case type.BROKER_DIS_CART_ID:
            return {
                ...state,
                DistcartId: action.payload.Id,
                DistshowButton: action.payload.flag
            }

        case type.CART_ROW_DATA:
            return {
                ...state,
                foliono: action.payload.folionum,
                plan: action.payload.plan
            }

        case type.PUSH_DIST_CARTID_REG_BROKER:
            return {
                ...state,
                regDistCartId_new: action.payload
            }

        case type.PUSH_DIST_CARTID_DIR_BROKER:
            return {
                ...state,
                dirDistCartId_new: action.payload
            }

        case type.SHOW_BANK_ERR:
            return {
                ...state,
                error: action.payload
            }

        case type.SHOW_MANDATE_ERR:
            return {
                ...state,
                error: action.payload
            }

        case type.SHOW_UTRNO_ERR:
            return {
                ...state,
                error: action.payload
            }

        case type.SET_DIST_FLAG:
            return {
                ...state,
                addDist: action.payload
            }

        case type.ISIPCHK:
            return {
                ...state,
                iSipChk: action.payload
            }

        case type.ISMANDATE:
            return {
                ...state,
                isMandate: action.payload
            }

        case type.ISMANDATEAVAIL:
            return {
                ...state,
                isMandateAvail: action.payload
            }

        case type.ISTWOPAYMENT:
            return {
                ...state,
                isTwoPayment: action.payload
            }

        case type.PROCESS_FOLIOS_FOR_SELECT:
            return {
                ...state,
                selectFolio: action.payload
            }
        case type.RESET_PAYMENT_MODE:
            return {
                ...state,
                LUMP_TYPE: null,
                ISIP_TYPE: null,
                SIP_TYPE: null
            }
        case type.SAVE_BUCKET_ID:
            return {
                ...state,
                bucketId: action.payload
            }
        case type.MANDATE_NAME:
            return {
                ...state,
                MANDATE_NAME: action.payload
            }

        case type.MANDATE_NUMBER:
            return {
                ...state,
                MANDATE_NUMBER: action.payload
            }

        case type.MANDATE_IHNO:
            return {
                ...state,
                MANDATE_IHNO: action.payload
            }
        case type.BUCKET_ID:
            return {
                ...state,
                BUCKET_ID: action.payload
            }
        case type.ALL_FUND_DETAILS:
            return {
                ...state,
                ALL_FUND_DETAILS: action.payload.ALL_FUND_DETAILS
            }
        default:
            return state
    }
}